module.exports = __webpack_public_path__ + "img/pverse_pverseme.gm.e1efde4.png";